(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    // Progressive pagination dots for product card galleries
  // Shows max 5 dots that shift as you navigate (like Instagram/iOS)
  document.addEventListener('slideshow:select', (event) => {
    const slideshow = event.target;
    if (!slideshow) return;

    // Find the parent card-gallery
    const cardGallery = slideshow.closest('.card-gallery');
    if (!cardGallery) return;

    // Dots are rendered INSIDE card-gallery
    const dotsContainer = cardGallery.querySelector('.gallery-pagination-dots');
    if (!dotsContainer) return;

    const dots = dotsContainer.querySelectorAll('.gallery-pagination-dot');
    if (!dots.length) return;

    const { index } = event.detail;
    const totalSlides = parseInt(dotsContainer.dataset.totalSlides, 10) || dots.length;
    const maxDots = 5;

    if (totalSlides <= maxDots) {
      // Simple case: just highlight the active dot
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
        dot.classList.remove('dot-small', 'dot-tiny');
      });
    } else {
      // Progressive dots: calculate window and sizes
      // Keep active dot centered (position 2 of 0-4) when possible
      const centerPos = 2;

      // Calculate the window start (which slide the first dot represents)
      let windowStart = index - centerPos;

      // Clamp window to valid range
      if (windowStart < 0) {
        windowStart = 0;
      } else if (windowStart > totalSlides - maxDots) {
        windowStart = totalSlides - maxDots;
      }

      // Which position in the 5 dots is active
      const activeDotIndex = index - windowStart;

      // Update dots
      dots.forEach((dot, i) => {
        const slideIndex = windowStart + i;

        // Set active state
        dot.classList.toggle('active', i === activeDotIndex);

        // Set size classes based on position in window
        // Edge dots are smaller when there's more content beyond them
        const isFirstDot = i === 0;
        const isLastDot = i === maxDots - 1;
        const hasMoreBefore = windowStart > 0;
        const hasMoreAfter = windowStart + maxDots < totalSlides;

        // Make edge dots smaller when there's more content
        dot.classList.remove('dot-small', 'dot-tiny');
        if (isFirstDot && hasMoreBefore) {
          dot.classList.add('dot-small');
        }
        if (isLastDot && hasMoreAfter) {
          dot.classList.add('dot-small');
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
